// extracted by mini-css-extract-plugin
export default {"list":"FriendList_list__oI1cf"};